import request from '@/utils/request';

export function fetchList(query) {
  return request({
    url: '/vehicles',
    method: 'get',
    params: query,
  });
}

export function fetchVehicle(id) {
  return request({
    url: '/vehicles/' + id,
    method: 'get',
  });
}

export function fetchVehicleHistory(id) {
  return request({
    url: '/vehicles/' + id + '/driverhistory',
    method: 'get',
  });
}

export function deleteVehicleHistoryEntry(vehicleId, id) {
  return request({
    url: '/vehicles/' + vehicleId + '/driverhistory/' + id,
    method: 'delete',
  });
}

export function updateVehicleHistoryEntry(vehicleId, id, data) {
  return request({
    url: '/vehicles/' + vehicleId + '/driverhistory/' + id,
    method: 'post',
    data
  });
}

export function fetchPv(id) {
  return request({
    url: '/articles/' + id + '/pageviews',
    method: 'get',
  });
}

export function createArticle(data) {
  return request({
    url: '/article/create',
    method: 'post',
    data,
  });
}

export function updateArticle(data) {
  return request({
    url: '/article/update',
    method: 'post',
    data,
  });
}
